import { Feedback, Text } from '@stone-payments/jade'

import { type KycStatusOnboardingProps } from '../kyc-onboarding.component'

import { KycStatusContainer } from './kyc-status-container'

export const KycStatusAnalysis = ({ actionButton }: KycStatusOnboardingProps) => {
  return (
    <KycStatusContainer actionButton={actionButton}>
      <Feedback variant="neutral" icon="circle-clock" title="Seus dados vão ser analisados em até 2 horas">
        <Text className="text-center" color="medium">
          Após análise, vamos te dar um <strong>retorno pelo e-mail</strong> cadastrado na Stone. Se estiver tudo certo,
          você vai conseguir acessar a conta pelo app e pelo computador.
        </Text>
      </Feedback>
    </KycStatusContainer>
  )
}
